import { createContext } from 'react';

import { OrganizationState } from './types';

export const OrganizationContext = createContext<OrganizationState>({
  isReady: false,
  setCurrentOrganization: (organization) => organization,
});
